import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const vocabulariesManifest: FeatureManifest = {
  id: 'english-knowledge-vocabularies',
  path: 'english-knowledge/vocabularies/catalogs/*',
  navPath: '/english-knowledge/vocabularies/catalogs',
  label: 'Danh mục',
  description: 'Kho từ vựng tiếng Anh gắn kết theo nhãn Taxonomy',
  navigationGroup: {
    id: 'vocabulary',
    label: 'Từ vựng',
  },
  load: () => import('./entry'),
}
